<div class="sessions-container">
  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
      containerClass="loading-box"></ng-lottie>
  </div>

  <div *ngIf="!loading">
    <!-- Barra de controles -->
    <div class="calendar-controls">
      <!-- Toggle vista Lista / Calendario -->
      <div class="view-toggle">
        <button class="toggle-btn" [class.active]="viewMode === 'lista'" (click)="viewMode = 'lista'">
          <i class="fa-regular fa-list"></i>
          <span>Lista</span>
        </button>
        <button class="toggle-btn" [class.active]="viewMode === 'calendario'" (click)="viewMode = 'calendario'">
          <i class="fa-regular fa-calendar"></i>
          <span>Calendario</span>
        </button>
      </div>

      <div class="btn-create m-0" (click)="createSession()">
        <i class="fal fa-plus-circle"></i>
        <p class="m-0">Crear sesión/es</p>
      </div>
    </div>

    <!-- Navegación mes (solo calendario) -->
    <div class="calendar-navigation" *ngIf="viewMode === 'calendario'">
      <button class="nav-button" (click)="previousMonth()">
        <i class="fa-regular fa-chevron-left"></i>
      </button>
      <button class="nav-button" (click)="nextMonth()">
        <i class="fa-regular fa-chevron-right"></i>
      </button>
      <span class="current-month">{{ monthNames[currentMonth] }} {{ currentYear }}</span>
    </div>

    <!-- VISTA CALENDARIO -->
    <div class="calendar-wrapper" *ngIf="viewMode === 'calendario'">
      <div class="calendar">
        <!-- Encabezados de días de la semana -->
        <div class="calendar-header">
          <div class="calendar-day-header" *ngFor="let day of weekDays">
            {{ day }}
          </div>
        </div>

        <!-- Días del calendario -->
        <div class="calendar-body">
          <div
            class="calendar-day"
            *ngFor="let day of calendarDays"
            [class.other-month]="!day.isCurrentMonth"
            [class.today]="isToday(day.date)"
            [class.past-day]="isPastDay(day.date)"
            (click)="handleDayClick(day, $event)">

            <!-- Botón agregar sesión (aparece en hover) -->
            <button
              *ngIf="!isPastDay(day.date)"
              class="btn-add-day"
              (click)="createSessionForDay(day, $event)">
              <i class="fa-solid fa-plus"></i>
            </button>

            <!-- Número del día -->
            <div class="day-number" [class.past-day]="isPastDay(day.date)">
              <span *ngIf="isToday(day.date)" class="today-badge">{{ day.dayNumber }} {{ monthNames[day.date.getMonth()].substring(0, 3) }}</span>
              <ng-container *ngIf="!isToday(day.date)">
                {{ day.dayNumber }}
                <span class="day-month" *ngIf="!day.isCurrentMonth">
                  {{ monthNames[day.date.getMonth()].substring(0, 3) }}
                </span>
              </ng-container>
            </div>

            <!-- Eventos del día -->
            <div class="day-events" *ngIf="day.events.size > 0" (click)="$event.stopPropagation()">
              <div
                class="event-item"
                *ngFor="let sessionData of getVisibleSessions(day)"
                [class]="getEventColorClass(sessionData)"
                (click)="openDayDialog(day, $event)">
                <div class="event-content">
                  <span class="event-time">{{ getEventTime(sessionData.session) }}</span>
                  <span class="event-title">{{ sessionData.event.title }}</span>
                </div>
                <i class="event-icon fa-light fa-eye-slash" *ngIf="sessionData.event?.cancelled || sessionData.event?.status === 'cancelled'"></i>
                <i class="event-icon fa-light fa-eraser" *ngIf="sessionData.event?.draft === true && !sessionData.event?.cancelled"></i>
                <i class="event-icon fa-light fa-arrows-repeat" *ngIf="sessionData.session.id_recurring_session && !sessionData.event?.cancelled && !sessionData.event?.draft"></i>
              </div>

              <!-- Contador de eventos adicionales -->
              <div class="more-events" *ngIf="getAdditionalSessionsCount(day) > 0" (click)="openDayDialog(day, $event)">
                +{{ getAdditionalSessionsCount(day) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VISTA LISTA -->
    <div class="list-wrapper" *ngIf="viewMode === 'lista'">
      <ng-container *ngIf="listSessions.length > 0; else emptyList">
        <ng-container *ngFor="let session of listSessions; let i = index">

          <!-- Cabecera de mes -->
          <div class="list-month-header"
            *ngIf="i === 0 || getListSessionMonth(session) !== getListSessionMonth(listSessions[i - 1])">
            {{ getListSessionMonth(session) }}
          </div>

          <div class="list-session-item" [class.past]="isPastDay(session.start_date?.split(' ')[0])">
            <div class="list-session-color-bar" [class.inactive]="session.active === false"></div>

            <div class="list-session-date">
              <span class="list-day">{{ getSessionDate(session) | date:'dd' }}</span>
              <span class="list-weekday">{{ getSessionDate(session) | date:'EEE' | uppercase }}</span>
            </div>

            <div class="list-session-time">
              <i class="fa-regular fa-clock"></i>
              <span *ngIf="!session.all_day">{{ getEventTime(session) }}h</span>
              <span *ngIf="session.all_day">Todo el día</span>
            </div>

            <div class="list-session-badges">
              <span class="badge-active" *ngIf="session.active !== false">
                <i class="fa-solid fa-circle-check"></i> Activa
              </span>
              <span class="badge-inactive" *ngIf="session.active === false">
                <i class="fa-solid fa-circle-xmark"></i> Inactiva
              </span>
              <span class="badge-recurring" *ngIf="session.id_recurring_session">
                <i class="fa-light fa-arrows-repeat"></i> Recurrente
              </span>
            </div>

            <button class="list-session-edit" (click)="openSessionFromList(session)">
              <i class="fa-light fa-pen"></i>
              <span>Editar</span>
            </button>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #emptyList>
        <div class="list-empty">
          <i class="fa-light fa-calendar-xmark"></i>
          <p>No hay sesiones creadas todavía</p>
        </div>
      </ng-template>
    </div>

  </div>
</div>
